// Mock data for Divyanka Karmakar Portfolio

export const portfolioItems = [
  {
    id: 1,
    title: "Pyramid Structured Handbag",
    category: "Bags",
    image: "https://customer-assets.emergentagent.com/job_design-consult-5/artifacts/krgqtbrb_Leather%20bag.jpg",
    description: "An innovative pyramid-shaped leather handbag featuring geometric laser-cut detailing and brass hardware. A statement piece that combines architectural design with functional craftsmanship.",
    client: "Private Collection",
    year: "2024"
  },
  {
    id: 2,
    title: "Artisan Crossbody Collection",
    category: "Bags",
    image: "https://customer-assets.emergentagent.com/job_design-consult-5/artifacts/chs75eua_Cross-body%20bag.png",
    description: "Technical development showcase featuring hand-woven detailing on vegetable-tanned leather. Complete tech pack documentation from concept to final product.",
    client: "Artisan Brand Partnership",
    year: "2024"
  },
  {
    id: 3,
    title: "Women's Belt Collection - Technical Design",
    category: "Belts",
    image: "https://customer-assets.emergentagent.com/job_design-consult-5/artifacts/nc16rnjo_design-leather-belts-for-men-and-women-with-detailed-technical-drawing-and-specs.jpg",
    description: "Comprehensive belt design project featuring detailed technical drawings, material specifications, and production-ready specs for women's leather belts.",
    client: "Fashion Brand Consultation",
    year: "2024"
  },
  {
    id: 4,
    title: "Men's Leather Backpack & Accessories",
    category: "Bags",
    image: "https://customer-assets.emergentagent.com/job_design-consult-5/artifacts/5pb9pmml_Mens%20Leather%20jacket%20and%20Bagpack.jpg",
    description: "Premium men's leather accessories collection featuring a rugged backpack design alongside coordinated belt and wallet pieces. Complete lifestyle presentation.",
    client: "Men's Lifestyle Brand",
    year: "2023"
  },
  {
    id: 5,
    title: "Collection Tech Pack - Technical Development",
    category: "Technical Development",
    image: "https://customer-assets.emergentagent.com/job_design-consult-5/artifacts/1mipvgd9_COLLECTION%20TECHPACK.jpg",
    description: "Complete technical package documentation showcasing detailed specifications, measurements, material callouts, and construction guidelines for a leather goods collection. Production-ready technical development.",
    client: "Brand Development Project",
    year: "2024"
  },
  {
    id: 6,
    title: "Crocheted Crossbody Bag",
    category: "Bags",
    image: "https://customer-assets.emergentagent.com/job_design-consult-5/artifacts/50lgvaa0_Crocheted%20crossbody%20bag.png",
    description: "A unique fusion of traditional crochet craftsmanship with contemporary leather accessories design. Features intricate hand-crocheted body with premium leather straps and hardware details.",
    client: "Artisan Collaboration",
    year: "2024"
  },
  {
    id: 7,
    title: "Structured Side Bag",
    category: "Bags",
    image: "https://customer-assets.emergentagent.com/job_design-consult-5/artifacts/ag4sarzq_Side%20Bag.jpg",
    description: "Elegant structured side bag design featuring clean lines, quality leather construction, and versatile styling. Perfect for everyday professional use with sophisticated aesthetic appeal.",
    client: "Private Label Design",
    year: "2024"
  }
];

export const services = [
  {
    id: 1,
    title: "Collection Design",
    description: "End-to-end creative direction from concept to final presentation, including moodboards, sketching, and digital rendering.",
    features: ["Trend Research & Analysis", "Moodboard Development", "Hand & Digital Sketching", "3D Rendering & Visualization", "Color & Material Selection"]
  },
  {
    id: 2,
    title: "Technical Development",
    description: "Precision technical documentation and prototyping to bring designs from paper to production-ready specs.",
    features: ["Tech Pack Creation", "Pattern Development", "Prototype Sampling", "Material Sourcing", "Cost Analysis"]
  },
  {
    id: 3,
    title: "Vendor Management & Production Oversight",
    description: "Connecting your brand with vetted manufacturers, managing communication, and conducting quality audits on your behalf.",
    features: ["Vendor Identification & Vetting", "Communication Management", "Quality Control Audits", "Production Timeline Coordination", "Compliance & Standards Verification"]
  }
];

export const processSteps = [
  { id: 1, title: "Concept", description: "Initial creative vision, research, and moodboard development" },
  { id: 2, title: "Design & Tech Pack", description: "Detailed sketches, technical drawings, and production specifications" },
  { id: 3, title: "Vendor Sourcing", description: "Identifying and vetting quality manufacturers aligned with your brand" },
  { id: 4, title: "Quality Control Oversight", description: "Production monitoring, audits, and final quality assurance" }
];

export const aboutData = {
  name: "Divyanka Karmakar",
  title: "Leather Accessories Designer & Strategy Consultant",
  bio: "With a foundation in design excellence from the National Institute of Fashion Technology (NIFT), Kolkata, I bring over years of specialized experience in leather and non-leather accessories design. My work spans the complete product development lifecycle — from initial concept sketching to manufacturing oversight.",
  extendedBio: "I collaborate with international fashion brands, startups, and private labels to create collections that balance aesthetic vision with commercial viability. My expertise includes bags, belts, wallets, and small leather goods, with a deep understanding of both traditional craftsmanship and contemporary production methods.",
  credentials: ["NIFT Kolkata Alumna", "Leather & Non-Leather Specialist", "End-to-End Product Development", "International Brand Collaboration"]
};

export const heroImage = "https://images.unsplash.com/photo-1644185711758-7f7237b215b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxsZWF0aGVyJTIwY3JhZnRpbmclMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzY5MzU5MTY3fDA&ixlib=rb-4.1.0&q=85";

export const workspaceImage = "https://images.pexels.com/photos/4452603/pexels-photo-4452603.jpeg";
